import React from 'react';
import logo from "../Assets/logo.jpg";
import useResponsive from '../hooks/useResponsive';
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaTwitter } from "react-icons/fa";

const COL = [
  { title: 'Courses', links: [{ label: 'Mobile App Dev', section: 'courses' }, { label: 'Full Stack', section: 'courses' }, { label: 'AI / ML', section: 'courses' }, { label: 'Cybersecurity', section: 'courses' }, { label: 'Cloud Computing', section: 'courses' }] },
  { title: 'Company', links: [{ label: 'About Us', section: 'about' }, { label: 'Our Team', section: null }, { label: 'Careers', section: null }, { label: 'Blog', section: null }, { label: 'Events', section: null }] },
  { title: 'Support', links: [{ label: 'Contact Us', section: 'contact' }, { label: 'FAQ', section: null }, { label: 'Scholarship', section: null }, { label: 'EMI Options', section: null }, { label: 'Alumni', section: null }] },
];

export default function Footer({ scrollTo }) {
  const { isMobile, isTablet } = useResponsive();
  const go = (section) => { if (section) scrollTo(section); };

  const paddingH = isMobile ? 16 : isTablet ? 24 : 40;
  const gridCols = isMobile ? '1fr 1fr' : isTablet ? '1fr 1fr 1fr' : '1.6fr 1fr 1fr 1fr';

  const iconStyle = {
    color: '#a0adc3',
    transition: '0.2s',
    cursor: 'pointer'
  };

  return (
    <footer style={{ borderTop: '1px solid rgba(255,255,255,0.05)', padding: `48px ${paddingH}px 24px`, background: '#060a14', fontFamily: "'DM Sans',sans-serif" }}>
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>

        <div style={{ display: 'grid', gridTemplateColumns: gridCols, gap: isMobile ? 24 : 36, marginBottom: 36 }}>

          {/* Brand */}
          <div style={{ gridColumn: isMobile ? '1 / -1' : 'auto' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12 }}>
              <img src={logo} alt="trinity Global" style={{ width: 34, height: 34, objectFit: 'contain', borderRadius: 6 }} />
              <span style={{ fontFamily: "'Outfit',sans-serif", fontWeight: 800, fontSize: 18, color: '#fff' }}>
                Trinity <span style={{ color: '#f97316' }}>Global</span>
              </span>
            </div>
            <p style={{ fontSize: 12, color: '#a6b0be', lineHeight: 1.7, maxWidth: 220 }}>
              India ka premium IT training center. Real skills, real projects, real placements since 2018.
            </p>
          </div>

          {/* Columns */}
          {COL.map(col => (
            <div key={col.title}>
              <h5 style={{ fontFamily: "'Outfit',sans-serif", fontSize: 13, fontWeight: 700, color: '#f4f6f8', marginBottom: 16 }}>
                {col.title}
              </h5>
              {col.links.map(l => (
                <button
                  key={l.label}
                  onClick={() => go(l.section)}
                  style={{
                    display: 'block',
                    background: 'none',
                    border: 'none',
                    padding: 0,
                    fontSize: 12,
                    color: '#cfd7e3',
                    cursor: l.section ? 'pointer' : 'default',
                    marginBottom: 8,
                    fontFamily: "'DM Sans',sans-serif",
                    textAlign: 'left',
                    transition: 'color 0.2s',
                    width: '100%'
                  }}
                  onMouseEnter={e => { e.currentTarget.style.color = l.section ? '#f97316' : '#f0f3f7'; }}
                  onMouseLeave={e => { e.currentTarget.style.color = '#d1dae6'; }}
                >
                  {l.label}
                </button>
              ))}
            </div>
          ))}

        </div>

        {/* Bottom */}
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          borderTop: '1px solid rgba(255,255,255,0.04)',
          paddingTop: 20,
          flexWrap: 'wrap',
          gap: 10
        }}>
          <p style={{ fontSize: 11, color: '#bfc8d6' }}>
            © 2025 Trinity Global Institute. All rights reserved.
          </p>

          {/* Social Icons */}
          <div style={{ display: 'flex', gap: 18 }}>
            <a href="#" style={iconStyle}
              onMouseEnter={e => e.currentTarget.style.color = '#1877f2'}
              onMouseLeave={e => e.currentTarget.style.color = '#a0adc3'}>
              <FaFacebookF size={16} />
            </a>

            <a href="#" style={iconStyle}
              onMouseEnter={e => e.currentTarget.style.color = '#E1306C'}
              onMouseLeave={e => e.currentTarget.style.color = '#a0adc3'}>
              <FaInstagram size={16} />
            </a>

            <a href="#" style={iconStyle}
              onMouseEnter={e => e.currentTarget.style.color = '#0A66C2'}
              onMouseLeave={e => e.currentTarget.style.color = '#a0adc3'}>
              <FaLinkedinIn size={16} />
            </a>

            <a href="#" style={iconStyle}
              onMouseEnter={e => e.currentTarget.style.color = '#1DA1F2'}
              onMouseLeave={e => e.currentTarget.style.color = '#a0adc3'}>
              <FaTwitter size={16} />
            </a>
          </div>
        </div>


        <div style={{ textAlign: 'center', marginTop: 20 }}>
          <p style={{ fontSize: 12, color: '#9aa6b2' }}>
            Designed and Developed by{' '}
            <a
              href="https://www.linkedin.com/in/tanisha-garg-70116b313/"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: '#60a5fa',
                fontWeight: 600,
                textDecoration: 'none'
              }}
              onMouseEnter={e => e.currentTarget.style.textDecoration = 'underline'}
              onMouseLeave={e => e.currentTarget.style.textDecoration = 'none'}
            >
              Tanisha
            </a>
          </p>
        </div>

      </div>
    </footer>
  );
}